import { Grid } from '@mui/material';
import BlockImage from 'components/layout/BlockImages/BlockImage/BlockImage';
import config from 'config';
import React, { useEffect, useState } from 'react';
import { ProductType } from 'types/product.types';
import ImageUrlResizer from 'utils/image-url-resizer';
import { useIsScreenSizeMax } from 'utils/screen-size';

import { ProductImageCarousel } from '../index';

const numberOfProductImages = config.get('numberOfProductImages');

type ProductImagesProps = {
  product: ProductType;
};

const ProductImagesNoCrop = (props: ProductImagesProps) => {
  const { product } = props;
  const [activeImage, setActiveImage] = useState(product?.images?.[0]);

  const isMobile = useIsScreenSizeMax('md');

  // Set active image
  useEffect(() => {
    if (product && product.images) {
      product.images = product?.images?.slice(0, numberOfProductImages);
      setActiveImage(product?.images?.[0]);
    }
  }, [product]);

  return (
    <>
      {isMobile ? (
        <div style={{ position: 'relative', width: '100%' }}>
          <ProductImageCarousel product={product} responsiveCarousel={true} isNewLister={product.shop?.isNewLister} />
        </div>
      ) : (
        <Grid container item md={6} direction="column" wrap="nowrap">
          <div className="product-images__main-image" style={{ position: 'relative' }}>
            <BlockImage
              alt=""
              stretch={false}
              status={product.status}
              src={ImageUrlResizer.resize(activeImage?.original, 1200, false)}
              blurhash={activeImage?.blurHash}
              isGridItem={false}
              showImageLoader={true}
              isMainBlockImage={true}
              isNewLister={product.shop?.isNewLister}
              newListerBadgeProps={{
                className: 'spacing-main',
              }}
            />
          </div>

          <div className="product-images__nav-images-wrapper">
            <Grid container className="product-images__nav-images">
              {product?.images
                ?.filter((img) => img.id !== activeImage.id)
                ?.map((img) => (
                  <BlockImage
                    alt=""
                    status={product.status}
                    showStatus={false}
                    key={'alt-image-key-' + (img.title || img.thumbnail)}
                    xs={4}
                    md={4}
                    src={img?.thumbnail}
                    blurhash={img?.blurHash}
                    onClick={() => setActiveImage(img)}
                    showImageLoader={true}
                  />
                ))}
            </Grid>
          </div>
        </Grid>
      )}
    </>
  );
};

export default ProductImagesNoCrop;
